import React from 'react';

export const Ipad = ({ className }) => {
  return (
    <svg viewBox="0 0 82 133" fill="none" className={className}>
      <rect
        x="2"
        y="2.30518"
        width="77.1748"
        height="128.652"
        rx="2.94968"
        fill="white"
        stroke="#2A4365"
        strokeWidth="4"
      />
      <circle cx="41.0001" cy="12.6793" r="2.96981" fill="#2A4365" />
    </svg>
  );
};
